<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Forma de Pagamento">
          <listar-forma-pagamento />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarFormaPagamento from '@/components/patio/ListarFormaPagamento'
export default {
  data() {
    return {
      page: {
        title: 'Gerenciamento de Formas de Pagamento',
      },
      breadcrumbs: [
        {
          text: 'Formas de Pagamento',
          disabled: false,
          to: '/patio/patio',
        },
        {
          text: 'Formas de Pagamento',
          disabled: false,
        },
      ],
    }
  },
  components: {
    ListarFormaPagamento,
  },
}
</script>

<style></style>
